import { z } from 'zod';

const LoginFormSchema = z.object({
  email: z.string().email({ message: 'The email must be a valid email address' }),
  password: z.string().min(1, { message: 'The password field is required' }),
});
type LoginFormType = z.infer<typeof LoginFormSchema>;

export { LoginFormSchema };
export type { LoginFormType };
